
import axios from 'axios';

const URL = 'https://api.delta.exchange/v2/products';
const API_KEY = 'f33a484cf794d08d0148764789aaba32';

export const fetchWeather = async(query) => {
    const{data} = await axios.get(URL);
    // console.log(data);
    return data;
}
